import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
// import {setJobId} from "../../../actions/actionFunctions";
import {setAssignQuoteCloneMode, toggleShowAssignQuotePopup} from "../../../actions/assignPopupFunctions";
import Analytics from "../../../analytics";
import Config from "../../../config";

const CloneQuoteButton = (props) => {

  // const {setJobId, toggleShowAssignQuotePopup} = props;
  const {toggleShowAssignQuotePopup, fabricatorData, setAssignQuoteCloneMode} = props;

  const cloneButtonIsVisible = Config.isDevMode() || (fabricatorData.isCaesarStone && document.kvConfig.showBackToDashboard);
  if (!cloneButtonIsVisible) {
    return null
  }

  const handleCloneQuoteClick = () => {
    Analytics.sendClickEvent("order-complete-clone-quote");
    // document.kvConfig.jobId = null; // clear current job
    // setJobId(0); // clear current job
    setAssignQuoteCloneMode(true); // show new assign quote popup
    toggleShowAssignQuotePopup(true); // show new assign quote popup
  }

  return (
    <button className="materials-button materials-button--clone" onClick={handleCloneQuoteClick}>
      <span className="materials-button__text"><FormattedMessage id="header.cloneButton"/></span>
    </button>
  )
};

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  // setJobId,
  setAssignQuoteCloneMode,
  toggleShowAssignQuotePopup
};

export default connect(mapStateToProps, mapDispatchToProps)(CloneQuoteButton)

